export const emptyStateStyles = `
  .es-root {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-3);
    text-align: center;
    padding: var(--space-10) var(--space-6);
    max-width: 460px;
    margin: 0 auto;
  }
  /* Tighter padding for a per-tab empty inside an otherwise populated screen. */
  .es-root--compact {
    padding: var(--space-8) var(--space-5);
  }
  /* Brand medallion carrying the screen's design-system <Icon> glyph. The glyph
     inherits \`color\`, so the whole medallion is one brand-tinted unit.
     --es-halo is a local knob so a scoped override (e.g. the small quadrant
     panels in OutcomeGraphStrongWeakStyles) can shrink the halo with the disc. */
  .es-medallion {
    --es-halo: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    border-radius: var(--radius-full);
    font-size: 34px;
    line-height: 1;
    background: var(--medallion-bg);
    border: 1px solid var(--medallion-border);
    box-shadow: var(--glass-hi-soft), 0 0 0 var(--es-halo) var(--medallion-halo);
    margin-bottom: var(--space-2);
    color: var(--brand-600);
  }
  /* Size the glyph off the medallion's font-size (not the <Icon size> prop), so
     a scoped font-size override scales the glyph exactly like it scaled an emoji.
     CSS wins over the SVG width/height presentation attributes. */
  .es-medallion svg {
    display: block;
    width: 1em;
    height: 1em;
  }
  .es-title {
    font-size: var(--fs-xl);
    font-weight: 700;
    color: var(--text-primary);
  }
  .es-desc {
    font-size: var(--fs-base);
    color: var(--text-muted);
    max-width: 360px;
    margin: 0;
    line-height: 1.5;
  }
  .es-action {
    margin-top: var(--space-3);
  }
`;
